import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '=',
        course: '='
    },
    template: `
        <div class="modal-header" id="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
            <h2>{{ 'historic.occurrence.Add course participation history' | translate }}</h2>
        </div>
        <div class="modal-body">
            <div ng-if="vm.showNavigationError && vm.showAddButton" class="alert alert-danger">
                {{ 'historic.occurrence.navigation_error' | translate }}
            </div>
            <div class="loader02" ng-if="vm.formLoading">
                <p>{{ 'general.Please wait. Actions with large amount of data take more time than usual' | translate }}</p>
            </div>
            <div class="form">
                <div class="row">
                    <form-row error="vm.form.errors.courseIsArchived">
                        <span class="label">{{ 'historic.occurrence.Course' | translate }}</span>
                        <div class="items">
                            <span class="text">{{ vm.course.activeI18n.name }}</span>
                            <form-row-error></form-row-error>
                        </div>

                    </form-row>
                </div>
                <form-row error="vm.form.errors.versionId">
                    <label class="label">{{ 'historic.occurrence.Version' | translate }}</label>
                    <div class="items">
                        <select ng-model="vm.form.model.versionId" class="form-control">
                            <option
                                ng-repeat="courseVersion in vm.courseVersions"
                                value="{{ courseVersion.id }}"
                               >{{ courseVersion.name }}</option>
                        </select>
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                <form-row error="vm.form.errors.completionType || vm.form.errors.completionDate || vm.form.errors.csv">
                    <label class="label">{{ 'historic.occurrence.Course completion date' | translate }}</label>
                    <div class="items">
                        <ul class="checkboxes">
                            <li>
                                <label>
                                    <input
                                        type="radio"
                                        ng-model="vm.form.model.completionType"
                                        ng-value="vm.COURSE_HISTORIC_OCCURRENCE_COMPLETION_TYPE_ENUM.KEYS.SAME_FOR_ALL"
                                        ng-change="vm.handleCompletionTypeChange()"
                                        name="r01"
                                    >
                                    {{ 'historic.occurrence.Same for all participants' | translate }}
                                </label>
                            </li>
                            <li ng-if="vm.form.model.completionType===vm.COURSE_HISTORIC_OCCURRENCE_COMPLETION_TYPE_ENUM.KEYS.SAME_FOR_ALL">
                                <datepicker-api ng-model="vm.form.model.completionDate"></datepicker-api>
                            </li>
                            <li>
                                <label>
                                    <input
                                        type="radio"
                                        ng-model="vm.form.model.completionType"
                                        ng-value="vm.COURSE_HISTORIC_OCCURRENCE_COMPLETION_TYPE_ENUM.KEYS.INDIVIDUAL"
                                        ng-change="vm.handleCompletionTypeChange()"
                                        name="r01"
                                    >
                                    {{ 'historic.occurrence.Assign completion date individually' | translate }}
                                </label>
                            </li>
                            <li>
                                <label>
                                    <input
                                        type="radio"
                                        ng-model="vm.form.model.completionType"
                                        ng-value="vm.COURSE_HISTORIC_OCCURRENCE_COMPLETION_TYPE_ENUM.KEYS.FROM_CSV"
                                        ng-change="vm.handleCompletionTypeChange()"
                                        name="r01"
                                    >
                                    {{ 'historic.occurrence.Upload CSV with completion dates' | translate }}
                                </label>
                            </li>
                            <li ng-if="vm.form.model.completionType===vm.COURSE_HISTORIC_OCCURRENCE_COMPLETION_TYPE_ENUM.KEYS.FROM_CSV">
                                <ul class="actions01">
                                    <li>
                                        <a ng-click="vm.downloadTemplate()" class="btn ico-download">
                                            {{ 'user.Download bulk upload template' | translate }}
                                            <small>({{ 'general.updated' | translate }}: 18.08.2025)</small>
                                        </a>
                                    </li>
                                </ul>
                                <upload-csv
                                    model="vm.form.model.employees"
                                    on-parse="vm.onCsvParsed(rows, filename)"
                                    on-delete="vm.onCsvDeleted()"
                                    skip-header="true"
                                ></csv-upload>
                            </li>
                            <div ng-if="vm.csvErrors.length" class="alert alert-danger">
                                <ul>
                                    <li ng-repeat="error in vm.csvErrors track by $index">{{ error }}</li>
                                </ul>
                            </div>
                        </ul>
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
            </div>
            <div>
                <h3>{{ 'historic.occurrence.Participants' | translate }}</h3>
                <div ng-if="vm.form.model.completionType===vm.COURSE_HISTORIC_OCCURRENCE_COMPLETION_TYPE_ENUM.KEYS.INDIVIDUAL
                    || vm.form.model.completionType===vm.COURSE_HISTORIC_OCCURRENCE_COMPLETION_TYPE_ENUM.KEYS.SAME_FOR_ALL">
                    <div ng-if="vm.form.errors.employees && !vm.userIds.length" class="alert alert-danger">
                        {{ 'historic.occurrence.At least one employee must be checked' | translate }}
                    </div>
                    <ul class="tabs01">
                        <li>
                            <a ng-click="vm.changeTab()"
                                ng-class="{ active: vm.targetsTab }"
                            >{{ 'historic.occurrence.Based on targets' | translate }}</a>
                        </li>
                        <li>
                            <a ng-click="vm.changeTab()"
                            ng-class="{ active: !vm.targetsTab }"
                            >{{ 'historic.occurrence.Customized' | translate }}</a>
                        </li>
                    </ul>
                    <form-row error="vm.error">
                        <form-row-error></form-row-error>
                    </form-row>
                    <modals-courses-historic-occurrence-employee-targets
                        ng-if="vm.targetsTab && !vm.loading"
                        course="vm.course"
                        user-ids="vm.userIds"
                        classifiers="vm.classifiers"
                        show-navigation-error="vm.showNavigationError"
                        show-add-button="vm.showAddButton"
                        form="vm.form"
                    />
                    <modals-courses-historic-occurrence-employee-customized
                        ng-if="!vm.targetsTab && !vm.loading"
                        course="vm.course"
                        user-ids="vm.userIds"
                        classifiers="vm.classifiers"
                        show-navigation-error="vm.showNavigationError"
                        show-add-button="vm.showAddButton"
                        form="vm.form"
                    />
                </div>
                <div ng-if="vm.form.model.completionType===vm.COURSE_HISTORIC_OCCURRENCE_COMPLETION_TYPE_ENUM.KEYS.FROM_CSV">
                    <div class="alert alert-plain" ng-if="!vm.form.model.employees.length">
                        <h3>{{ 'general.This table has no content yet' | translate }}</h3>
                    </div>
                    <div class="well table-wrapper" ng-if="vm.form.model.employees.length">
                        <table class="data01">
                            <thead>
                                <tr>
                                    <th>{{ 'user.E-mail' | translate }}</th>
                                    <th>{{ 'user.Personal code' | translate}}</th>
                                    <th>{{ 'user.Country' | translate}}</th>
                                    <th>{{ 'planning.Course completion date' | translate }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr ng-repeat="(index, item) in vm.form.model.employees" ng-if="index < vm.csvPreviewItemsLimit">
                                    <td>{{ item.email }}</td>
                                    <td>{{ item.idCode }}</td>
                                    <td>{{ item.country }}</td>
                                    <td>{{ item.completionDate }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary">
                    <button
                        ng-if="vm.showAddButton"
                        class="btn main"
                        type="button"
                        ng-click="vm.save()"
                     >{{ 'general.Add' | translate }}</button>
                </li>
                <li>
                    <button
                        class="btn discrete"
                        type="button"
                        ng-click="vm.uibModalInstance.dismiss()"
                    >{{ 'general.Cancel' | translate }}</button>
                </li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($translate, lodash, toastr, ModalService, ListFactory, FormFactory,
                 ClassifierResource, UserResource, CourseHistoryResource, $window,
                 COURSE_HISTORIC_OCCURRENCE_COMPLETION_TYPE_ENUM, Upload,
                 ResponseService, MomentService, AuthResource) {
        this.$translate = $translate;
        this.$window = $window;
        this.lodash = lodash;
        this.toastr = toastr;
        this.ModalService = ModalService;
        this.ListFactory = ListFactory;
        this.FormFactory = FormFactory;
        this.ClassifierResource = ClassifierResource;
        this.UserResource = UserResource;
        this.CourseHistoryResource = CourseHistoryResource;
        this.COURSE_HISTORIC_OCCURRENCE_COMPLETION_TYPE_ENUM = COURSE_HISTORIC_OCCURRENCE_COMPLETION_TYPE_ENUM;
        this.Upload = Upload;
        this.ResponseService = ResponseService;
        this.MomentService = MomentService;
        this.AuthResource = AuthResource;
    }

    $onInit () {
        this.targetsTab = true;
        this.loading = true;
        this.formLoading = false;
        this.csvPreviewItemsLimit = 10;
        this.previousCompletionTypeSelected = null;

        this.ClassifierResource.query({ pageSize: 0 }).$promise
            .then(classifiers => {
                this.classifiers = classifiers;
                this.loading = false;
            });

        this.form = this.FormFactory.create(
            {
                versionId: null,
                completionType: this.COURSE_HISTORIC_OCCURRENCE_COMPLETION_TYPE_ENUM.KEYS.SAME_FOR_ALL,
                completionDate: null
            },
            model => this.CourseHistoryResource.occurrenceCreate({}, model).$promise
        );

        this.initDefaultValues();
    }

    handleCompletionTypeChange () {
        if (this.previousCompletionTypeSelected === this.COURSE_HISTORIC_OCCURRENCE_COMPLETION_TYPE_ENUM.KEYS.FROM_CSV
            && this.form.model.completionType !== this.COURSE_HISTORIC_OCCURRENCE_COMPLETION_TYPE_ENUM.KEYS.FROM_CSV) {
            this.initDefaultValues();
        }
        if (this.previousCompletionTypeSelected !== this.COURSE_HISTORIC_OCCURRENCE_COMPLETION_TYPE_ENUM.KEYS.FROM_CSV
            && this.form.model.completionType === this.COURSE_HISTORIC_OCCURRENCE_COMPLETION_TYPE_ENUM.KEYS.FROM_CSV) {
            this.initDefaultValues();
        }

        this.previousCompletionTypeSelected = this.form.model.completionType;
    }

    downloadTemplate () {
        this.AuthResource
            .requestTacToken().$promise
            .then(({ token }) => {
                const url = `${SEED_CORE.ENV.API_URL}course/history/export-template?lang=${this.$translate.use()}&tacToken=${token}`;
                this.$window.open(url);
            });
    }

    onCsvParsed (rows) {
        this.initDefaultValues();
        if (rows.length) {
            this.form.model.employees = [];
            this.lodash.forEach(rows, row => {
                this.form.model.employees.push({
                    email: row[0],
                    idCode: row[1],
                    country: row[2],
                    completionDate: this.MomentService.formatDate(row[3], 'DD.MM.YYYY', 'YYYY-MM-DD')
                });
            });
            this.showAddButton = true;
        }
        else {
            this.showAddButton = false;
        }
    }

    onCsvDeleted () {
        this.initDefaultValues();
    }

    changeTab () {
        if (this.showAddButton) {
            this.showNavigationError = true;
        }
        else {
            this.targetsTab = !this.targetsTab;
            this.initDefaultValues();
        }
    }

    initDefaultValues () {
        this.csvErrors = [];
        this.form.errors = [];
        this.form.model.employees = [];
        this.userIds = [];
        this.files = [];
        this.showNavigationError = false;
        this.showAddButton = false;
        this.courseVersions = this.course.courseVersions.map((courseVersion) => {
            return {
                id: courseVersion.id,
                isArchived: courseVersion.isArchived,
                name: courseVersion.isArchived ? `${courseVersion.name} (${this.$translate.instant('version.Archived')})` : courseVersion.name
            };
        });
        this.courseVersions = this.lodash.sortBy(this.courseVersions, 'isArchived');
    }

    beforeSave () {
        // remove unselected files
        this.lodash.forEach(this.form.model.files, (file, userId) => {
            if (this.form.model.employees[userId] === undefined) {
                delete this.form.model.files[userId];
            }
        });
    }

    save () {
        this.form.errors = [];
        this.showAddButton = false;
        this.error = false;
        this.formLoading = true;

        if (this.form.model.completionType === this.COURSE_HISTORIC_OCCURRENCE_COMPLETION_TYPE_ENUM.KEYS.FROM_CSV) {
            this.saveCsvInBatches();
            return;
        }

        this.beforeSave();

        if (this.form.model.completionType === this.COURSE_HISTORIC_OCCURRENCE_COMPLETION_TYPE_ENUM.KEYS.INDIVIDUAL) {
            this.form.model.completionDate = null;
        }

        const uploadUrl = `${SEED_CORE.ENV.API_URL}course/history/occurrence-create`;
        const method = 'POST';

        this.Upload
            .upload({
                url: uploadUrl,
                data: this.form.model,
                method
            })
            .then(() => {
                this.toastr.success(this.$translate.instant('general.Changes saved'));
                this.uibModalInstance.close();
                this.formLoading = false;
            }).catch((response) => {
                this.form.errors = this.ResponseService.parseErrors(response);
                this.showAddButton = true;
                this.formLoading = false;
                // window.scrollTo() is not working here
                // use native js scrollIntoView() instead
                document.getElementById('modal-header').scrollIntoView();
            });
    }

    generateBatchKey () {
        return Date.now().toString(36) + Math.random().toString(36).substring(2, 8);
    }

    saveCsvInBatches () {
        this.csvErrors = [];
        const uploadUrl = `${SEED_CORE.ENV.API_URL}course/history/occurrence-create`;
        const method = 'POST';

        const employees = this.form.model.employees;
        const batchSize = 100;
        const batches = [];

        for (let i = 0; i < employees.length; i += batchSize) {
            batches.push(employees.slice(i, i + batchSize));
        }

        const sendBatches = (validateOnly) => {
            const url = validateOnly ? `${uploadUrl}?validateOnly=true` : uploadUrl;
            let chain = Promise.resolve();
            const batchKey = this.generateBatchKey();

            batches.forEach((batch, index) => {
                chain = chain.then(() => {
                    const payload = angular.copy(this.form.model);
                    payload.employees = batch;
                    payload.validateOnly = validateOnly;
                    payload.batchIndexStart = index * batchSize;
                    payload.batchKey = batchKey;

                    return this.Upload.upload({ url, data: payload, method })
                        .catch((response) => {
                            if (validateOnly) {
                                this.form.errors = this.ResponseService.parseErrors(response);
                                const errors = this.ResponseService.parseErrors(response);
                                const messages = Object.values(errors)
                                .flat()
                                .map(err => (typeof err === 'object' ? Object.values(err)[0] : err));

                                this.csvErrors = [
                                    ...new Set([...this.csvErrors, ...messages])
                                ];
                                return Promise.resolve();
                            }

                            return Promise.reject(response);
                        });
                });
            });
            return chain;
        };

        // 1st round: validation only
        sendBatches(true)
            .then(() => {
                if (this.csvErrors.length) {
                    // Found errors in validation round — don't proceed
                    this.showAddButton = true;
                    this.formLoading = false;
                    document.getElementById('modal-header').scrollIntoView();
                    return;
                }

                // 2nd round: actual save
                sendBatches(false).then(() => {
                    this.toastr.success(this.$translate.instant('general.Changes saved'));
                    this.uibModalInstance.close();
                    this.formLoading = false;
                });
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/historicOccurrence/index.js